module.exports = __webpack_public_path__ + "8b920a0762b9fb1182166757205d7b4b.svg";